const PRIOR_YEARS_DEFAULT = 'current_month'

export default class GraphPeriodsInterpreter {
  stringsToOptions(periods, ledgersPerYear = 12) {
    let frequency = this.frequency(periods, ledgersPerYear)
    const priorYears =
      frequency === 'yearly' ? this.priorYears(periods) : PRIOR_YEARS_DEFAULT

    frequency = this.adjustFrequencyForLedgers(frequency, ledgersPerYear)

    return { frequency, priorYears }
  }

  optionsToString({ range, frequency, priorYears, previousPeriods }) {
    const list = []
    previousPeriods = previousPeriods || []

    for (let delta = range.start; delta <= range.end; delta++) {
      const interpretedPeriods =
        delta === 0
          ? this.currentYearOptionsInterpreter(frequency)
          : this.otherYearsOptionsInterpreter(frequency, priorYears)

      interpretedPeriods.forEach((period) => {
        const previousPeriod = previousPeriods.find((previousPeriod) => {
          return (
            previousPeriod.delta === delta && previousPeriod.periods === period
          )
        })
        const id = previousPeriod ? previousPeriod.id : undefined
        list.push({ id, delta, periods: period })
      })
    }

    // Destroy periods that are no longer being used
    const idsToKeep = list.map((el) => el.id)
    previousPeriods.map((period) => {
      if (idsToKeep.includes(period.id)) {
        return
      }
      list.push({ id: period.id, _destroy: true })
    })

    return list
  }

  // private

  currentYearOptionsInterpreter(frequency) {
    switch (frequency) {
      case 'monthly':
        return ['current_period', 'previous_periods_current_year']
      case 'quarterly':
        return ['current_quarter', 'previous_periods_as_quarters_current_year']
      case 'yearly':
        return ['current_period']
    }
  }

  otherYearsOptionsInterpreter(frequency, priorYears) {
    switch (frequency) {
      case 'monthly':
        return ['all_periods_current_year']
      case 'quarterly':
        return ['all_periods_as_quarters']
      case 'yearly':
        if (priorYears === 'current_month') {
          return ['current_period']
        } else if (priorYears === 'end_of_bookyear') {
          return ['last_period_of_current_year']
        }
    }
  }

  frequency(periods, ledgersPerYear) {
    if (!periods || periods.length === 0) {
      if (ledgersPerYear > 4) return 'monthly'
      else if (ledgersPerYear > 1) return 'quarterly'
      else return 'yearly'
    }

    let selectedYearStrings = periods.filter((period) => period.delta === 0)

    if (selectedYearStrings.length === 0) {
      selectedYearStrings = periods.filter(
        (period) => period.delta === periods[0].delta
      )
    }

    const periodStrings = selectedYearStrings.map((period) => period.periods)

    if (this.hasOtherThanCurrent(periodStrings)) {
      if (this.hasQuarters(periodStrings)) {
        return 'quarterly'
      }

      return 'monthly'
    }

    return 'yearly'
  }

  priorYears(periods) {
    if (!periods || periods.length === 0) {
      return PRIOR_YEARS_DEFAULT
    }

    const periodStrings = periods.map((period) => period.periods)

    if (this.hasLastPeriodOfCurrentYear(periodStrings)) {
      return 'end_of_bookyear'
    }

    return 'current_month'
  }

  hasOtherThanCurrent(periodStrings) {
    return !!periodStrings.find(
      (string) =>
        ![
          'last_period_of_current_year',
          'current_period',
          'current_quarter',
        ].includes(string)
    )
  }

  hasQuarters(periodStrings) {
    return !!periodStrings.find((string) => string.includes('_quarter'))
  }

  hasLastPeriodOfCurrentYear(periodStrings) {
    return !!periodStrings.find(
      (string) => string === 'last_period_of_current_year'
    )
  }

  adjustFrequencyForLedgers(frequency, ledgersPerYear) {
    if (ledgersPerYear < 4) {
      return 'yearly'
    } else if (ledgersPerYear < 12 && frequency === 'monthly') {
      return 'quarterly'
    }

    return frequency
  }
}
